import Service from '../Service';
import { ResponseSuccessBodyUserInfo, ResponseErrorBody } from '../../types';
import Request from '../Request';
import { addFingerprintToRequest } from './utils';

export default async function() {
  const request = await addFingerprintToRequest(
    new Request('/api/auth/admin/profile').setMethod('GET')
  );
  const service = new Service<ResponseSuccessBodyUserInfo, ResponseErrorBody>(
    request
  );
  return await service.send();
}
